<template>
  <div class="container d-flex flex-column h-100">
    <p
      class="font-weight-bold text-left mb-0 mt-4 open-sans-medium"
      v-if="user.isAgency && $route.query.steps == 'grid'"
    >
      Precio para Agencias
    </p>
    <transition name="fade" mode="out-in">
      <plans-grid
        v-if="$route.query.steps == 'grid'"
        :plans="plans"
        @selectPlan="selectPlan"
      />
      <agency-payments
        v-if="$route.query.steps == 'payment-method' && user.isAgency"
        :user="user"
        :selectedPlan="selectedPlan"
        @rechargeSelected="rechargeSelected"
      />
      <payment-method-selector
        v-if="$route.query.steps == 'payment-method' && !user.isAgency"
        :selectedPlan="selectedPlan"
        :isRecharge="false"
      />
      <bancolombia
        :selectedPlan="selectedPlan"
        :rechargeSelectedPlan="rechargeSelectedPlan"
        v-if="$route.query.steps == 'bancolombia'"
      />
      <pse
        :selectedPlan="
          rechargeSelectedPlan == null ? selectedPlan : rechargeSelectedPlan
        "
        :isRecharge="user.isAgency"
        v-if="$route.query.steps == 'pse'"
      />
    </transition>
    <div
      :class="
        'mt-auto  ' +
          ($route.query.steps !== 'bancolombia' ? 'pb-4 mb-5' : 'mb-4 mb-md-5')
      "
    >
      <whatsapp-Button
        :phone="company_data.client_service"
        :text="
          'Buenos días, estoy tratando de realizar un pago en la ciudad de ' +
            kCity +
            ' en la categoría ' +
            kCategory +
            ' con el número de teléfono ' +
            user.username
        "
        :buttonlabel="'Contactar un asesor'"
        :buttonClass="'link'"
      />
    </div>
  </div>
</template>

<script>
import settings from "@/api/settings"
import WhatsappButton from "@/components/UI/WhatsappButton.vue"
import PaymentMethodSelector from "@/components/UI/Plans/PaymentMethodSelector"
import PlansGrid from "@/components/UI/Plans/PlansGrid"
import AgencyPayments from "@/components/UI/Plans/AgencyPayments"
import Bancolombia from "@/components/UI/Plans/Bancolombia"
import Pse from "@/components/UI/Plans/Pse"
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      company_data: settings.company_data,
      selectedPlan: {},
      rechargeSelectedPlan: null,
      settings,
    }
  },
  methods: {
    rechargeSelected(planSelected) {
      console.log("PLAN DE RECARGA SELECCIONADO ", planSelected)
      this.rechargeSelectedPlan = planSelected
    },
    selectPlan(plan) {
      /* if(this.user.isAgency){

      } else {

      } */
      console.log(plan, "USET", this.user)
      this.selectedPlan = plan
      this.$router.push({
        path: "plans",
        query: {
          steps: "payment-method",
          navbarT:
            !this.user.isAgency || this.user.credits > plan.price
              ? `Pagar ${this.settings.addThousands(plan.price)}`
              : "Recarga saldo",
        },
      })
    },
    /*     addThousands(value) {
      if (settings.CURRENCY == "COP" && value / 1000 < 1) {
        value = value * 1000
        value = Number(value).toLocaleString("es-CO", {
          style: "currency",
          currency: "COP",
          minimumFractionDigits: 0,
        })
        return value
      } else {
        return Number(value).toLocaleString(`es-${settings.COUNTRY}`, {
          style: "currency",
          currency: settings.CURRENCY,
          minimumFractionDigits: 0,
        })
      }
    }, */
  },
  mounted() {},
  components: {
    WhatsappButton,
    AgencyPayments,
    PaymentMethodSelector,
    PlansGrid,
    Bancolombia,
    Pse,
  },
  props: ["collectionDBname"],
  watch: {
    collectionDBname() {
      console.log("Watch", this.collectionDBname)
    },
  },
  computed: {
    ...mapGetters(["user", "kCity", "kCategory"]),
    extraInfo() {
      return this.$store.getters[`${this.collectionDBname}_extraInfo`]
    },
    plans() {
      return this.$store.getters[this.collectionDBname]
    },
    dataShape() {
      return this.$store.getters[`${this.collectionDBname}_dataShape`]
    },
  },
}
</script>

<style></style>
